import type { MutableRefObject } from "react";
import React from "react";
import { LegacyCard } from "@shopify/polaris";
import QueryString from "qs";
import type { IHorseVariant } from "../../../../api_utils/types";
import type { HorseInventoryLevel } from "../../../../api_utils/requests";
import { QuantityChangeForm } from "../../../common/QuantityChangeForm";
import HorseLink from "../../../common/HorseLink";

export function Quantity({
  horseInventoryLevels,
  horseVariant,
  setErrorMessage,
  discardCallback,
  saveCallback,
  setIsDirty,
}: {
  readonly horseInventoryLevels: HorseInventoryLevel[];
  readonly horseVariant: IHorseVariant;
  readonly setErrorMessage: (message: string) => void;
  readonly saveCallback: MutableRefObject<() => Promise<HorseInventoryLevel[]>>;
  readonly discardCallback: MutableRefObject<() => void>;
  readonly setIsDirty: (isDirty: boolean) => void;
}): JSX.Element {
  // link to 'Inventory History' tab that shows only data for this horseVariant
  const inventoryLevelHistoriesUriParams = {
    horse_variant_id: horseVariant.id,
    collection: horseVariant.discarded ? 1 : 0,
  };
  const inventoryLevelHistoriesUri = `/inventory_level_histories?${QueryString.stringify(
    inventoryLevelHistoriesUriParams,
  )}`;

  return (
    <LegacyCard>
      <LegacyCard.Header title="Quantity">
        <HorseLink url={inventoryLevelHistoriesUri}>Show history</HorseLink>
      </LegacyCard.Header>
      <LegacyCard.Section>
        <QuantityChangeForm
          disabled={horseVariant.discarded}
          discardCallback={discardCallback}
          horseInventoryLevels={horseInventoryLevels}
          horseVariantId={horseVariant.id}
          saveCallback={saveCallback}
          setErrorMessage={setErrorMessage}
          setIsDirty={setIsDirty}
          tracked={horseVariant.tracked}
        />
      </LegacyCard.Section>
    </LegacyCard>
  );
}
